import { FareFlightInterface } from 'pages/AwardTickets/awardTicket.interface';
import { createContext, useState } from 'react';

interface IContext {
  dataForm: any;
  updateGloablDataForm: any;
  setFareFlights: any;
  fareFlights: Array<FareFlightInterface>;
}

export const AwardTicketsContext = createContext<IContext>({
  dataForm: null,
  updateGloablDataForm: null,
  setFareFlights: null,
  fareFlights: [],
});

const AwardTicketProvider: React.FC = ({ children }) => {
  const [dataForm, setDataForm] = useState<any>(null);
  const [fareFlights, setFareFlights] = useState<Array<FareFlightInterface>>([]);

  const updateGloablDataForm = (data: any) => setDataForm(data);

  return (
    <AwardTicketsContext.Provider
      value={{
        dataForm,
        updateGloablDataForm,
        setFareFlights,
        fareFlights,
      }}
    >
      {children}
    </AwardTicketsContext.Provider>
  );
};

export default AwardTicketProvider;
